'use client';
import cx from 'classnames';

import { useIsNavigationCondensed } from '~/system/providers/IsNavigationCondensed/IsNavigationCondensed.context';

import styles from './layout-main.module.scss';

export interface LayoutMainProps {
  children: React.ReactNode;
  className?: string;
}

export function LayoutMain({ children, className }: LayoutMainProps) {
  const isNavigationCondensed = useIsNavigationCondensed();

  return (
    <div className={cx(styles.root, isNavigationCondensed && styles.navCondensed, className)}>
      {children}
    </div>
  );
}
